import React, { useState, useEffect } from 'react';
import { Table, Form, Pagination } from 'react-bootstrap';
import './AllRequests.css';

import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
function makeid(length) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}


function AllRequests() {
  const [requestErrorMessage, setRequestErrorMessage] = useState('');
  const [requests, setRequests] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [searchQuery, setSearchQuery] = useState('');
  
  function fetchRequestData(setRequestErrorMessage, setRequests) {
    setRequestErrorMessage('');
    setRequests([]);

    fetch('https://qwj7xbfkm8.execute-api.us-west-2.amazonaws.com/Arti-prod-deployment/connections')
      .then(response => {
        if (!response.ok) {
          throw new Error('Error ' + response.status);
        }
         return response.json();
      })
      .then(data => {
        const parsedData = JSON.parse(data.body);
  
        setRequests(parsedData);
      })
      .catch(error => {
        setRequestErrorMessage('Error fetching data. Please try again.'); // Set error message here
      });
}

  useEffect(() => {
    fetchRequestData(setRequestErrorMessage, setRequests);
  }, []); // Empty dependency array ensures the effect runs only once on component mount

  // Pagination logic
  const totalItems = requests.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  // Change page
  const paginate = pageNumber => setCurrentPage(pageNumber);

  // Change items per page
  const handleItemsPerPageChange = e => {
    setItemsPerPage(parseInt(e.target.value));
    setCurrentPage(1); // Reset to first page when changing items per page
  };

  // Filter logic
  const handleSearchChange = e => {
    setSearchQuery(e.target.value);
  };

  // Clear search query
  const clearSearchQuery = () => {
    setSearchQuery('');
  };

  const filteredItems = requests.filter(
    item =>
      item.vpcid.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.finalstatus.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.initialstatus.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item['request-time'].toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.userid.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  // Pagination items
  let paginationItems = [];
  if (totalPages > 1) {
    paginationItems = Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  return (
    <div className="requests-container">
      <h2>All Connection Requests</h2>
      <div className="error-message">{requestErrorMessage}</div> {/* Render error message */}
      <Row>
        <Col md={9} lg={9} xl={9}>
      <Form.Control
        type="text"
        value={searchQuery}
        onChange={handleSearchChange}
        placeholder="Search..."
      />    </Col> <Col>
      {searchQuery && (
        <Button className="clear-search-button" onClick={clearSearchQuery}>
          Clear
        </Button>
      )}
      </Col>
      </Row>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>VPC ID</th>
            <th>Account ID</th>
            <th>Account Environment</th>
            <th>Region</th>
            <th>CIDR</th>
            <th>CR number</th>
            <th>Final Status</th>
            <th>Request Time</th>
            <th>User ID</th>
          </tr>
        </thead>
        <tbody>
          {currentItems.map((request, index) => (
            <tr key={index}>
              <td>{request.vpcid}</td>
              <td>{request.account_id}</td>
              <td>{request.accountEnvironment}</td>
              <td>{request.region}</td>
              <td>{request.CIDR}</td>
              <td>{request.CR_number}</td>
              <td>{request.finalstatus}</td>
              <td>{request['request-time']}</td>
              <td>{request.userid}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      <div className="pagination-select-container">
        <Row> <Col md={6} lg={6}>
        <Form.Select onChange={handleItemsPerPageChange} value={itemsPerPage}>
          <option value="5">5 per page</option>
          <option value="10">10 per page</option>
          <option value="15">15 per page</option>
          {/* Add more options as needed */}
        </Form.Select>
        </Col>
        <Col>
        <Pagination>
          <Pagination.First onClick={() => setCurrentPage(1)} disabled={currentPage === 1} />
          <Pagination.Prev onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : currentPage)} disabled={currentPage === 1} />
          {paginationItems.map((item, index) => (
            <Pagination.Item key={index} active={item === currentPage} onClick={() => setCurrentPage(item)}>
              {item}
            </Pagination.Item>
          ))}
          <Pagination.Next onClick={() => setCurrentPage(currentPage < totalPages ? currentPage + 1 : currentPage)} disabled={currentPage === totalPages} />
          <Pagination.Last onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages} />
        </Pagination>
        </Col>
        </Row>
      </div>
    </div>
  );
}

export default AllRequests;
